<template>
  <section>
    <h3 class="certificates-title">Certificates</h3>
    <div class="certificates-row">
      <span class="skill">Project Management</span>
      <span class="skill">Application Architect</span>
      <span class="skill">English Language for IT Specialist</span>
      <span class="skill">Cisco Network Specialist</span>
      <span class="technology">Angular</span>
      <span class="technology">Java</span>
    </div>
  </section>
</template>

<script>
export default {
  name: "ResumeCertificates"
};
</script>

<style lang="scss" scoped>
section {
  padding-top: 40px;
  line-height: 40px;
  padding-inline: 7vw;
}
.certificates-title {
  font-size: 1.55rem;
  color: #23415d;
  text-align: left;
  text-transform: uppercase;
  border-bottom: 1px solid #23415d;
}

.certificates-row {
  display: flex;
  gap: 5px;
  flex-flow: row wrap;
  padding: 10px;
  span {
    height: 25px;
    font-size: 11px;
    font-weight: 900;
    padding-inline: 5px;
    border-radius: 3px;
    display: flex;
    place-content: center;
    place-items: center;
  }
}

.technology {
  background-color: #f6fbff;
  color: black;
}
.skill {
  background-color: #f6fbff;
  color: black;
}
</style>